import Image from 'next/image'
import { FC } from 'react'

import { cn } from '@/app/utils'
import { CreatePassButton } from '@/components/entities/passes/ui/CreatePassButton'
import EmptyListPlug from '@/components/pages/plugs/EmptyListPlug'

type Props = {
  arePassesEmpty: boolean
  isCreateButton?: boolean
}

const EmptyPassesPlug: FC<Props> = ({
  arePassesEmpty,
  isCreateButton = false
}) => {
  const title = arePassesEmpty ? 'У вас нет пропусков' : 'Ничего не нашлось'
  const description = arePassesEmpty
    ? 'Закажите пропуск в Службе комфорта Sminex'
    : 'Попробуйте изменить параметры поиска или сбросить фильтры'

  const plugContent = (
    <EmptyListPlug
      title={title}
      description={description}
      className={cn(
        'mt-0 flex flex-1 items-center justify-center',
        arePassesEmpty ? 'sm:h-[30vh] xs:mt-0' : undefined,
        !isCreateButton && 'h-[48vh] sm:pb-56 sm:pt-12',
        isCreateButton && 'h-auto'
      )}
      image={
        <Image
          src={
            arePassesEmpty
              ? '/images/shared/BlankSheet.png'
              : '/images/shared/MagnifyingGlass.png'
          }
          alt={title}
          height={100}
          width={100}
        />
      }
      titleClassName="lg:text-24 sm:text-16"
      descriptionClassName="!text-16 sm:!text-12 text-grey-60"
    />
  )

  if (!isCreateButton) {
    return plugContent
  }

  return (
    <div className="flex flex-col gap-40 py-63 sm:gap-20 sm:pb-0 sm:pt-20">
      {plugContent}
      {isCreateButton && (
        <div className="flex w-full justify-center">
          <CreatePassButton />
        </div>
      )}
    </div>
  )
}

export { EmptyPassesPlug }
